import { render } from "./ParentTenantModal.vue?vue&type=template&id=194b3a01&scoped=true"
import script from "./ParentTenantModal.vue?vue&type=script&lang=js"
export * from "./ParentTenantModal.vue?vue&type=script&lang=js"

import "./ParentTenantModal.vue?vue&type=style&index=0&id=194b3a01&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194b3a01"]])

export default __exports__